import {
    GET_OTP_REQUEST,
    GET_OTP_SUCCESS,
    GET_OTP_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const getOtpReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_OTP_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case GET_OTP_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case GET_OTP_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default getOtpReducer;
